class FetchIdentityProvider {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchIdentityProvider;
